import { httpRequest } from './http-client';

export const getDuelsSyncStatus = () =>
    httpRequest('/v1/duels/status', { cache: false });

export const connectDuelsSync = (token) =>
    httpRequest('/v1/duels/connect', { method: 'POST', body: { token } });

export const disconnectDuelsSync = () =>
    httpRequest('/v1/duels/disconnect', { method: 'DELETE' });

/**
 * Import one chunk of games from duels.ink.
 * @param {object} params
 * @param {string|null} params.cursor - pagination cursor from previous response
 * @param {string|null} params.fromDate - ISO date string, only import games after this date
 * @param {number} params.chunkSize - how many games per request (default 50)
 * @param {boolean} params.ranked - filter ranked games only (default true)
 * @param {boolean} params.matchmaking - filter matchmaking only (default true)
 * @returns {{ processed, imported, pending, potentialDuplicates, skipped, nextCursor, done }}
 */
export const importDuelsChunk = (params = {}) =>
    httpRequest('/v1/duels/import', { method: 'POST', body: params });

/**
 * Get pending imports. type: 'deck_assignment' | 'potential_duplicate' | undefined (all)
 */
export const getPendingImports = (type) =>
    httpRequest('/v1/duels/pending', {
        query: type ? { type } : {},
        cache: false,
    });

/**
 * Confirm deck assignment for a pending import.
 * deckId: null means "import without deck" (deck will stay unlinked)
 */
export const confirmPendingImport = (id, deckId) =>
    httpRequest(`/v1/duels/pending/${id}/confirm`, {
        method: 'POST',
        body: { deckId: deckId || null },
    });

/**
 * Merge a potential duplicate — enriches the existing manual match with replay data.
 */
export const mergePendingImport = (id) =>
    httpRequest(`/v1/duels/pending/${id}/merge`, { method: 'POST', body: {} });

/**
 * Dismiss a pending import (delete without importing).
 */
export const dismissPendingImport = (id) =>
    httpRequest(`/v1/duels/pending/${id}`, { method: 'DELETE' });

/**
 * Re-check all deck_assignment pending items against current decks.
 * Items that now auto-match (diff <= 3) are imported automatically.
 */
export const retryAutoMatch = () =>
    httpRequest('/v1/duels/pending/retry-auto-match', { method: 'POST', body: {} });

/**
 * Confirm multiple pending imports at once (batch).
 */
export const confirmBatchPendingImport = (ids, deckId) =>
    httpRequest('/v1/duels/pending/confirm-batch', {
        method: 'POST',
        body: { ids, deckId: deckId || null },
    });
